import React from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box className='tab-panel-box'>
                    {children}
                </Box>
            )}
        </div>
    );
}

export default TabPanel;